<div class="d-flex flex-column min-vh-100">
  <app-header></app-header>
  <main class="flex-grow-1">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
  <app-cookie-consent></app-cookie-consent>
</div>